export class CandidateType {
	constructor() {
	}
} 
